export default __webpack_public_path__ + "static/media/zalo-promotion.76de015b.png";